import gql from 'graphql-tag';

export default gql`
    mutation AddEditJobLogs($input: AddEditJobLogsInput) {
        addEditJobLogs(input: $input) {
            errors
        }
    }
`;
